export default `
  <div class="wb-doc-page">
    <div class="doc-main-title">申請註銷盈寶賬號</div>

    <div class="doc-text doc-pb28">
      註銷賬號是不可恢復的操作，為保護您的合法權益，請務必謹慎操作，如您已確定要註銷賬號，請聯系
      <a class="doc-link" href="javascript:void(0);">在線客服</a>
      或致電人工客服進行註銷操作。
    </div>

    <div class="doc-text">客服熱線：+852 23709538</div>
  </div>
`
